import React, { type Dispatch } from "react";
import {
  initialState,
  type PromptLibraryAction,
  type PromptLibraryState,
} from "./useAllPrompts.web";

export const LibraryContext = React.createContext<{
  state: PromptLibraryState;
  dispatch: Dispatch<PromptLibraryAction>;
}>(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  { state: initialState, dispatch: () => {} }
);
